import { GenerateThresholdClass } from './generateThresholdClass';

export const generateTableRows = (classname, item, thresholdValue, isGrowthEnabled, isMidTestEnabled, isPercent) => {
  return (
    <>
      <td className={`${classname} border`}>{item.preTest != null && `${item.preTest}${isPercent ? '%' : ''}`}</td>
      <td className={`${classname} border`}>{item.preTestCompletion}%</td>
      {isMidTestEnabled &&
        <>
          <td className={`${classname} border`}>{item.midTest != null && `${item.midTest}${isPercent ? '%' : ''}`}</td>
          <td className={`${classname} border`}>{item.midTestCompletion}%</td>
        </>
      }
      {isGrowthEnabled && isMidTestEnabled &&
        <td className={`${classname} border ${GenerateThresholdClass(thresholdValue, item.preMidGrowth)}`}>{item.preMidGrowth != null && `${item.preMidGrowth}${isPercent ? '%' : ''}`}</td>
      }
      <td className={`${classname} border`}>{item.postTest != null && `${item.postTest}${isPercent ? '%' : ''}`}</td>
      <td className={`${classname} border`}>{item.postTestCompletion}%</td>
      {isGrowthEnabled && isMidTestEnabled &&
        <td className={`${classname} border ${GenerateThresholdClass(thresholdValue, item.midPostGrowth)}`}>{item.midPostGrowth != null && `${item.midPostGrowth}${isPercent ? '%' : ''}`}</td>
      }
      {isGrowthEnabled &&
        <td className={`${classname} border ${GenerateThresholdClass(thresholdValue, item.prePostGrowth)}`}>{item.prePostGrowth != null && `${item.prePostGrowth}${isPercent ? '%' : ''}`}</td>
      }
    </>
  );
};